import React from 'react';
import CompanyPhonesTabView from './CompanyPhonesTabView';
import { useCompanyPhonesTabController } from '../../../controllers';
import { CompanyPhonesTabProps } from '../../../types';

const CompanyPhonesTab = (props: CompanyPhonesTabProps) => {
  const viewModel = useCompanyPhonesTabController(props);
  return <CompanyPhonesTabView {...viewModel} />;
};

export default CompanyPhonesTab;
